import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { SpotExtended, SpotExtendedResponse, SpotsQueryParams } from '@frontend/spot/types';

const endpoint = '/spot-api/ext/v1';
export class SpotExtendedClient extends APIClient {
    public static async fetchSpotExtendeds(queryParams?: ApiQueryParams<SpotsQueryParams>): Promise<SpotExtendedResponse> {
        return this.apiPaginated<SpotExtendedResponse, SpotsQueryParams>(`${endpoint}/spots`, queryParams);
    }

    public static async fetchSpotExtended(accountId: string, spotId: string): Promise<SpotExtended> {
        const response = await this.fetch(`${endpoint}/accounts/${accountId}/spots/${spotId}`);
        return await this.handleResponse<SpotExtended>(response);
    }
}
